import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import * as React from 'react';
import { clsx } from 'clsx';
import { MainButton } from '../../MainButton';
import { MessengerLink } from '../../MessengerLink';
import { WebimChat } from '../../WebimChat';
import * as styles from './styles.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ConsultantWidgetDesktop = /*#__PURE__*/function (_React$Component) {
  function ConsultantWidgetDesktop() {
    var _this;
    _classCallCheck(this, ConsultantWidgetDesktop);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ConsultantWidgetDesktop, [].concat(args));
    _defineProperty(_this, "state", {
      isHovered: false
    });
    _defineProperty(_this, "onHover", function () {
      return _this.setState({
        isHovered: true
      });
    });
    _defineProperty(_this, "outHover", function () {
      return _this.setState({
        isHovered: false
      });
    });
    _defineProperty(_this, "open", function (e) {
      e.preventDefault();
      _this.outHover();
      _this.props.toggleOpen(true);
    });
    _defineProperty(_this, "close", function () {
      return _this.props.toggleOpen(false);
    });
    _defineProperty(_this, "onClick", function () {
      var chatOpened = _this.props.chatOpened;
      var isHovered = _this.state.isHovered;
      if (chatOpened) {
        _this.close();
      } else if (isHovered) {
        _this.outHover();
      }
    });
    return _this;
  }
  _inherits(ConsultantWidgetDesktop, _React$Component);
  return _createClass(ConsultantWidgetDesktop, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        propStyles = _this$props.styles,
        messengersLinks = _this$props.messengersLinks,
        tooltip = _this$props.tooltip,
        chatOpened = _this$props.chatOpened,
        webimProps = _this$props.webimProps,
        onReady = _this$props.onReady;
      var isHovered = this.state.isHovered;
      var buttonsVisible = isHovered && !chatOpened;
      return /*#__PURE__*/_jsxs("div", {
        className: clsx(styles['container'], propStyles),
        children: [!chatOpened && /*#__PURE__*/_jsx("div", {
          className: clsx(styles['tooltip'], isHovered && styles['tooltip-offset']),
          "data-testid": "ConsultantWidgetTooltip",
          children: tooltip
        }), /*#__PURE__*/_jsxs("div", {
          className: styles['btn-container'],
          onMouseEnter: this.onHover,
          onMouseLeave: this.outHover,
          children: [/*#__PURE__*/_jsxs("div", {
            className: clsx(styles['links'], !buttonsVisible && styles['links-hidden']),
            "data-testid": "MessengerLinks",
            children: [messengersLinks.map(function (linkParams) {
              return /*#__PURE__*/_jsx(MessengerLink, _objectSpread({}, linkParams), linkParams.type);
            }), /*#__PURE__*/_jsx(MessengerLink, {
              url: "/",
              type: "chat",
              onClick: this.open
            }, "chat")]
          }), /*#__PURE__*/_jsx(MainButton, {
            closedState: isHovered || chatOpened,
            onClick: this.onClick
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: styles['chat-container'],
          style: {
            display: chatOpened ? '' : 'none'
          },
          "data-testid": "WebimChat",
          children: /*#__PURE__*/_jsx(WebimChat, _objectSpread(_objectSpread({}, webimProps), {}, {
            isOpen: chatOpened,
            onClose: this.close,
            onReady: onReady
          }))
        })]
      });
    }
  }]);
}(React.Component);